// Date: 07/08/21
import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { PickList } from "primereact/picklist";
import _ from "lodash";
import {
  ADD_ARR_AREA_EVENT,
  DEL_ARR_AREA_EVENT,
} from "../../../store/constants/serviceEndpoint";
import Swal from "sweetalert2";
import * as enums from "../../../common/enum";
import { axiosWithHeaders } from "../../../store/constants/axiosWrapper";

export default function ConfigArea({ eventId, listArea, listAreaSelect, onReloadData }) {
  const [isEdit, setIsEdit] = useState(false);
  const [source, setSource] = useState([]);

  useEffect(() => {
    if (
      _.isArray(listAreaSelect) &&
      _.isArray(listArea)
    ) {
      const data = _.cloneDeep(listArea);
      const dataSelect = _.cloneDeep(listAreaSelect);
      const result = data.filter((item) => {
        const index = dataSelect.findIndex((x) => x.value === item.value);
        if (index === -1) {
          return true;
        }
        return false;
      });
      // // console.log(result);
      setSource(result);
    }
  }, [listArea, listAreaSelect]);
  // // console.log(eventId, listArea, listAreaSelect);

  const renderText = () => {
    const data = _.cloneDeep(listAreaSelect);
    let text = "";
    if (data !== undefined && data !== null && data.length > 0) {
      data.forEach((item) => {
        text += text === "" ? item.label : ", " + item.label;
      });
      return text;
    }
  };

  const areaTemplate = ({ label }) => {
    return (
      <div className="p-clearfix">
        <div style={{ fontSize: "14px" }}>{label}</div>
      </div>
    );
  };

  const onMoveAllToSource = ({ value }) => {
    Swal.fire({
      title: 'Thông báo',
      text: "Bạn có muốn loại bỏ những vùng này khỏi hoạt động không ?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Đồng ý!',
      cancelButtonText: 'Trở về'
    }).then((result) => {
      if (result.value) {
        let dataDelete = {}
        let arrSelect = value;
        let arrDelete = [];
        arrSelect.forEach((item) => {
          arrDelete.push(item.id)
        })
        dataDelete["list"] = arrDelete;

        axiosWithHeaders("post", DEL_ARR_AREA_EVENT, dataDelete)
        .then((response) => {
          if (response && response.data && response.status === enums.RESPONSE_OK) {
            const { 
              status, 
              message 
            } = response.data;
            if (status === enums.RESPONSE_OK) {
              Swal.fire("Thông báo", "Xóa vùng thành công", "success");
              onReloadData(eventId);
            } else {
              Swal.fire("Lỗi", message, "error");
            }
          }
        })
        .catch((err) => Swal.fire("Lỗi", err.toString(), "error")) 
        .finally(() => {
          setIsEdit(false);
        });
      }
    });
  };

  const onMoveAllToTarget = ({ value }) => {
    // console.log(value);
    let dataUpdate = {}
    let arrSelect = value;
    let arrUpdate = [];
    arrSelect.forEach((item) => {
      let obj = {}
      obj["EventId"] = eventId;
      obj["AreaId"] = item.value;
      arrUpdate.push(obj)
    })
    dataUpdate["Data"] = arrUpdate;
    axiosWithHeaders("post", ADD_ARR_AREA_EVENT, dataUpdate)
    .then((response) => {
      if (response && response.data && response.status === enums.RESPONSE_OK) {
        const { 
          status, 
          message 
        } = response.data;
        if (status === enums.RESPONSE_OK) {
          Swal.fire("Thông báo", "Thêm vùng thành công", "success");
          onReloadData(eventId);
        } else {
          Swal.fire("Lỗi", message, "error");
        }
      }
    })
    .catch((err) => Swal.fire("Lỗi", err.toString(), "error"))
    .finally(() => {
      setIsEdit(false);
    });
  };

  const onMoveToSource = ({ value }) => {
    Swal.fire({
      title: "Thông báo",
      text: "Bạn có muốn loại bỏ vùng này khỏi hoạt động không ?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Đồng ý!",
      cancelButtonText: "Trở về",
    }).then((result) => {
      if (result.value) {
        let dataDelete = {};
        let arrSelect = value;
        let arrDelete = [];
        arrSelect.forEach((item) => {
          arrDelete.push(item.id);
        });
        dataDelete["list"] = arrDelete;

        console.log(dataDelete);
        axiosWithHeaders("post", DEL_ARR_AREA_EVENT, dataDelete)
          .then((response) => {
            // console.log(response);
            if (response && response.data && response.status === enums.RESPONSE_OK) {
              const { 
                status, 
                message 
              } = response.data;
              if (status === enums.RESPONSE_OK) {
                Swal.fire("Thông báo", "Xóa vùng thành công", "success");
                onReloadData(eventId);
              } else {
                Swal.fire("Lỗi", message, "error");
              }
            }
          })
          .catch((err) => Swal.fire("Lỗi", err.toString(), "error")) 
          .finally(() => {
            setIsEdit(false);
          });
      }
    });
  };

  const onMoveToTarget = ({ value }) => {
    let dataUpdate = {}
    let arrSelect = value;
    let arrUpdate = [];
    arrSelect.forEach((item) => {
      let obj = {}
      obj["EventId"] = eventId;
      obj["AreaId"] = item.value;
      arrUpdate.push(obj)
    })
    dataUpdate["Data"] = arrUpdate;
    axiosWithHeaders("post", ADD_ARR_AREA_EVENT, dataUpdate)
    .then((response) => {
      if (response && response.data && response.status === enums.RESPONSE_OK) {
        const { 
          status, 
          message 
        } = response.data;
        if (status === enums.RESPONSE_OK) {
          Swal.fire("Thông báo", "Thêm vùng thành công", "success");
          onReloadData(eventId);
        } else {
          Swal.fire("Lỗi", message, "error");
        }
      }
    })
    .catch((err) => Swal.fire("Lỗi", err.toString(), "error"))
    .finally(() => {
      setIsEdit(false);
    });
  };

  return (
    <>
      <div className="row">
        <div
          className={`col-md-12 d-flex align-items-center position-relative ${
            isEdit ? `justify-content-center` : `justify-content-between`
          }`}
        >
          {!isEdit && <div style={{ minWidth: 100 }}></div>}
          <div style={{ fontSize: `1.5rem`, color: `red`, fontWeight: 700 }}>
            CÀI ĐẶT VÙNG
          </div>
          {!isEdit && (
            <div>
              <Button
                label="SỬA"
                icon="pi pi-pencil"
                className="p-button-raised p-button-secondary"
                onClick={() => setIsEdit(true)}
              />
            </div>
          )}
        </div>
      </div>
      <div className="row mt-3" style={{ minHeight: 35 }}>
        <div className="col-md-12">
          {listAreaSelect && listAreaSelect.length > 0 && !isEdit ? (
            <label>
              Các vùng đang diễn ra hoạt động:{" "}
              <span style={{ fontSize: 18, color: "red" }}>{renderText()}</span>
            </label>
          ) : (
            <>
              {!isEdit && (
                <b style={{ color: `red` }}>Chưa có vùng nào được chọn.</b>
              )}
            </>
          )}
        </div>
      </div>
      {isEdit && (
        <>
          <div className="row mt-3" style={{ minHeight: 35 }}>
            <div className="col-md-12">
              <PickList
                source={source}
                target={listAreaSelect}
                itemTemplate={areaTemplate}
                sourceHeader="Danh sách vùng"
                targetHeader="Đang chạy"
                onMoveToSource={onMoveToSource}
                onMoveAllToSource={onMoveAllToSource}
                onMoveToTarget={onMoveToTarget}
                onMoveAllToTarget={onMoveAllToTarget}
                responsive={true}
                sourceStyle={{ height: 300 }}
                targetStyle={{ height: 300 }}
              />
            </div>
          </div>
          <div className="row mt-5" style={{ minHeight: 35, marginBottom: 60 }}>
            <div className="col-md-12 text-center">
              <Button
                label="HỦY"
                icon="pi pi-times"
                className="p-button-raised p-button-secondary"
                onClick={() => setIsEdit(false)}
                style={{ minWidth: 110 }}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
}
